module.exports = __webpack_public_path__ + "img/cornell.eb6fb5d9.png";